var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81152 2.32227C11.8733 4.04377 14.4884 5.1239 17.3516 5.25781C17.4188 5.76566 17.4551 6.28389 17.4551 6.81055C17.455 11.8478 14.2746 16.141 9.81152 17.7959C5.34848 16.141 2.16803 11.8478 2.16797 6.81055C2.16797 6.28394 2.2033 5.76561 2.27051 5.25781C5.1341 5.12413 7.74953 4.04396 9.81152 2.32227ZM13.9385 6.75488C13.3457 6.1623 12.3847 6.16216 11.792 6.75488L8.79297 9.75293L7.83105 8.79102C7.23827 8.19823 6.27737 8.19824 5.68457 8.79102C5.09177 9.38381 5.09177 10.3447 5.68457 10.9375L7.7207 12.9736C8.31352 13.5662 9.27448 13.5663 9.86719 12.9736L13.9385 8.90137C14.5313 8.30857 14.5313 7.34768 13.9385 6.75488Z",
    fill: "#FA532E",
    stroke: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseOrange);
export default __webpack_public_path__ + "static/media/enterprise-orange.453fbc56fec5176709a96567916812bb.svg";
export { ForwardRef as ReactComponent };